/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast.  Keeping your custom
 * Javascript in this fill will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  // Add custom code below this line

  function cloneBadge(observer) {
    const badge = document.querySelector(".jdgm-preview-badge");
    const target = document.querySelector(".jdgm-widget-mobile");

    // Only clone if badge + target exist, and target doesn't already contain a badge
    if (badge && target && !target.querySelector(".jdgm-preview-badge")) {
      const cloned = badge.cloneNode(true);
      target.appendChild(cloned);
      console.log("✅ Badge cloned into .jdgm-widget-mobile");

      // Stop observing after success
      if (observer) observer.disconnect();
    }
  }

  // Create MutationObserver
  const observer = new MutationObserver(() => {
    cloneBadge(observer);
  });

  // Start observing
  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  // Run once immediately
  cloneBadge(observer);
  
  function consentmoAdaTweak() {
    const host = document.querySelector('csm-web-accessibility');
    if (!host?.shadowRoot) return;
    const wrap = host.shadowRoot.getElementById('csm-ada-compliance-wrapper');
    if (!wrap) return;
    wrap.style.setProperty('--ada-banner-z-index', '10000', 'important');
    wrap.style.setProperty('--ada-banner-bottom-px', '85px', 'important');
    wrap.style.setProperty('bottom', '85px', 'important');
  }

  let adaDebounceId;
  function scheduleConsentmoAdaTweak() {
    if (adaDebounceId) clearTimeout(adaDebounceId);
    adaDebounceId = setTimeout(() => {
      adaDebounceId = null;
      consentmoAdaTweak();
    }, 300);
  }

  new MutationObserver(scheduleConsentmoAdaTweak).observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class'],
  });
  window.addEventListener('resize', scheduleConsentmoAdaTweak);
  consentmoAdaTweak();
  let adaN = 0;
  const adaIv = setInterval(() => {
    consentmoAdaTweak();
    if (++adaN > 20) clearInterval(adaIv);
  }, 200);

  function getSelectedFlavor() {
    const checked = document.querySelector(
      '.selector-wrapper[data-option-handle="pick-flavor"] input[data-single-option-selector]:checked',
    );
    return (checked?.value || '').trim();
  }

  function applyFlavorSliderImages(flavor) {
    const items = document.querySelectorAll('[data-slider-alt]');
    if (!items.length) return;

    const filterFlavor = flavor === 'Chocolate' || flavor === 'Unflavored' ? flavor : '';
    let anyMatch = false;
    if (filterFlavor) {
      items.forEach((el) => {
        if ((el.getAttribute('data-slider-alt') || '').includes(filterFlavor)) anyMatch = true;
      });
    }

    items.forEach((el) => {
      const alt = el.getAttribute('data-slider-alt') || '';
      const hide = Boolean(filterFlavor && anyMatch && !alt.includes(filterFlavor));
      el.classList.toggle('is-flavor-hidden', hide);
      if (hide) {
        el.classList.remove('media--active', 'is-active');
        el.classList.add('media--hidden');
      } else {
        el.classList.remove('media--hidden');
      }
    });

    const visibleSlides = document.querySelectorAll('.product__slide[data-slider-alt]:not(.is-flavor-hidden)');
    visibleSlides.forEach((slide, index) => {
      slide.classList.toggle('media--active', index === 0);
      slide.classList.toggle('media--hidden', index !== 0);
    });
    document.querySelectorAll('.product__thumb[data-slider-alt]:not(.is-flavor-hidden)').forEach((thumb, index) => {
      thumb.classList.toggle('is-active', index === 0);
    });

    const firstVisible = visibleSlides[0];
    if (firstVisible) {
      const productImages = firstVisible.closest('product-images');
      const mediaId = firstVisible.getAttribute('data-media-id');
      if (productImages && mediaId) {
        productImages.dispatchEvent(
          new CustomEvent('theme:media:select', {
            bubbles: true,
            detail: { id: mediaId },
          }),
        );
      }
    }

    document.querySelectorAll('product-images').forEach(syncAbPdpGalleryNav);
  }

  function syncFlavorSlider() {
    applyFlavorSliderImages(getSelectedFlavor());
  }

  document.addEventListener('theme:variant:change', syncFlavorSlider);
  document.addEventListener('change', (event) => {
    if (event.target.matches('.selector-wrapper[data-option-handle="pick-flavor"] input[data-single-option-selector]')) {
      syncFlavorSlider();
    }
  });
  window.addEventListener('message', (event) => {
    if (event.data?.type === 'toku-native-flavor') {
      applyFlavorSliderImages(String(event.data.flavor || '').trim());
    }
  });
  syncFlavorSlider();

  customElements.whenDefined('product-images').then(() => {
    const ProductImages = customElements.get('product-images');
    if (!ProductImages) return;
    const proto = ProductImages.prototype;
    const isHiddenMedia = (el) => !el || !el.hasAttribute('data-image-id') || el.classList.contains('is-flavor-hidden');

    proto.getNextMediaId = function () {
      const currentMedia = this.getCurrentMedia();
      let nextMedia = currentMedia?.nextElementSibling;
      while (nextMedia && isHiddenMedia(nextMedia)) {
        nextMedia = nextMedia.nextElementSibling;
      }
      if (!nextMedia) {
        nextMedia = this.querySelector('[data-image-id]:not(.is-flavor-hidden)');
      }
      return nextMedia?.getAttribute('data-media-id');
    };

    proto.getPreviousMediaId = function () {
      const currentMedia = this.getCurrentMedia();
      let previousMedia = currentMedia?.previousElementSibling;
      while (previousMedia && isHiddenMedia(previousMedia)) {
        previousMedia = previousMedia.previousElementSibling;
      }
      if (!previousMedia) {
        const visible = this.querySelectorAll('[data-image-id]:not(.is-flavor-hidden)');
        previousMedia = visible[visible.length - 1];
      }
      return previousMedia?.getAttribute('data-media-id');
    };

    const galleryTestClass = 'ab-test-hide-gallery-badges';
    const syncGalleryHeight = () => {
      document.querySelectorAll('product-images').forEach((el) => {
        if (typeof el.setHeight === 'function') el.setHeight();
      });
    };
    let galleryTestOn = document.documentElement.classList.contains(galleryTestClass);
    new MutationObserver(() => {
      const next = document.documentElement.classList.contains(galleryTestClass);
      if (next === galleryTestOn) return;
      galleryTestOn = next;
      requestAnimationFrame(() => requestAnimationFrame(syncGalleryHeight));
    }).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    if (galleryTestOn) {
      requestAnimationFrame(syncGalleryHeight);
    }

    const originalSetActiveMedia = proto.setActiveMedia;
    proto.setActiveMedia = function (id) {
      const selected = id ? this.querySelector(`[data-media-id="${id}"]`) : null;
      if (selected?.classList.contains('is-flavor-hidden')) {
        id = this.querySelector('[data-image-id]:not(.is-flavor-hidden)')?.getAttribute('data-media-id');
      }
      const result = originalSetActiveMedia.call(this, id);
      syncAbPdpGalleryNav(this);
      return result;
    };

    document.querySelectorAll('product-images').forEach(bindAbPdpGalleryNav);

    let htmlClassSnapshot = document.documentElement.className;
    new MutationObserver(() => {
      const next = document.documentElement.className;
      if (next === htmlClassSnapshot) return;
      htmlClassSnapshot = next;
      document.querySelectorAll('product-images').forEach(syncAbPdpGalleryNav);
    }).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
  });

  function getAbGallerySlides(productImages) {
    return Array.from(productImages.querySelectorAll('.product__slide[data-image-id], .product__slide[data-media-id]')).filter(
      (slide) => !slide.classList.contains('is-flavor-hidden') && !slide.classList.contains('product__photo--blank'),
    );
  }

  function syncAbPdpGalleryNav(productImages) {
    const nav = productImages.querySelector('[data-ab-gallery-nav]');
    if (!nav) return;

    const slides = getAbGallerySlides(productImages);
    const prev = nav.querySelector('[data-ab-gallery-prev]');
    const next = nav.querySelector('[data-ab-gallery-next]');
    const dotsEl = nav.querySelector('[data-ab-gallery-dots]');
    const counter = productImages.querySelector('[data-ab-gallery-counter]');
    const active = productImages.querySelector('.product__slide.media--active:not(.is-flavor-hidden)');
    const index = Math.max(0, slides.indexOf(active));
    const galleryOff = document.documentElement.classList.contains('ab-test-pdp-gallery-off');
    const isGalleryB = !galleryOff && document.documentElement.classList.contains('ab-test-pdp-gallery-b');
    const isGalleryC = !galleryOff && !isGalleryB && document.documentElement.classList.contains('ab-test-pdp-gallery-c');

    if (counter) {
      counter.hidden = !isGalleryB || slides.length <= 1;
      if (slides.length > 0) {
        counter.textContent = `${index + 1}/${slides.length}`;
      }
    }

    const showNav = (isGalleryB || isGalleryC) && slides.length > 1;
    nav.hidden = !showNav;

    if (showNav) {
      if (dotsEl && dotsEl.children.length !== slides.length) {
        dotsEl.innerHTML = slides
          .map(
            (_, i) =>
              `<button type="button" class="ab-pdp-gallery-nav__dot" data-ab-gallery-dot="${i}" aria-label="${i + 1}"></button>`,
          )
          .join('');
      }

      dotsEl?.querySelectorAll('[data-ab-gallery-dot]').forEach((dot, i) => {
        dot.classList.toggle('is-active', i === index);
      });

      const canPrev = index > 0;
      const canNext = index < slides.length - 1;
      prev?.classList.toggle('is-active', canPrev);
      next?.classList.toggle('is-active', canNext);
      if (prev) prev.disabled = !canPrev;
      if (next) next.disabled = !canNext;
    }

    const peekSlide = isGalleryC && slides.length > 1 ? slides[index + 1] || null : null;
    productImages.querySelectorAll('.product__slide').forEach((slide) => {
      slide.classList.toggle('is-ab-peek', slide === peekSlide);
    });

    if (isGalleryC && typeof productImages.setHeight === 'function') {
      requestAnimationFrame(() => productImages.setHeight());
    }
  }

  function bindAbPdpGalleryNav(productImages) {
    const nav = productImages.querySelector('[data-ab-gallery-nav]');
    if (!nav || nav.dataset.bound === 'true') return;
    nav.dataset.bound = 'true';

    nav.querySelector('[data-ab-gallery-prev]')?.addEventListener('click', () => {
      const slides = getAbGallerySlides(productImages);
      const active = productImages.querySelector('.product__slide.media--active:not(.is-flavor-hidden)');
      const index = slides.indexOf(active);
      const prevSlide = slides[index - 1];
      const id = prevSlide?.getAttribute('data-media-id');
      if (id) productImages.selectMedia(id);
    });

    nav.querySelector('[data-ab-gallery-next]')?.addEventListener('click', () => {
      const slides = getAbGallerySlides(productImages);
      const active = productImages.querySelector('.product__slide.media--active:not(.is-flavor-hidden)');
      const index = slides.indexOf(active);
      const nextSlide = slides[index + 1];
      const id = nextSlide?.getAttribute('data-media-id');
      if (id) productImages.selectMedia(id);
    });

    nav.querySelector('[data-ab-gallery-dots]')?.addEventListener('click', (event) => {
      const dot = event.target.closest('[data-ab-gallery-dot]');
      if (!dot) return;
      const slides = getAbGallerySlides(productImages);
      const slide = slides[Number(dot.getAttribute('data-ab-gallery-dot'))];
      const id = slide?.getAttribute('data-media-id');
      if (id) productImages.selectMedia(id);
    });

    syncAbPdpGalleryNav(productImages);
  }
})();
